import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ArrUtil, EppPortlet, PageFilterConfig, PortletRepo, registerInnerWidget, tmpl2, FilterSchema, ShellService,WEB_PATH_HOME } from '@gspwidget/util';
import { PortletComponent, WidgetComponent } from '@gspwidget/widget-core';
import { ActivatedRoute } from '@angular/router';
import { DataJumpConfig, dataJumpOption, JumpTypes, Property, PropertyTypes, Widget, WidgetBase, WidgetDataService, WidgetDevkitService } from '@gspwidget/widget-devkit';
import { forkJoin } from 'rxjs';

export interface Tab {
  /** 仅作老配置项兼容 */
  portletId: string
  portletIds: string[]
  rightJump: DataJumpConfig
  title?: string
  feOnly?: {
    portlets?: EppPortlet[]
    widgetComp?: WidgetComponent
  }
}

/**
 * name = id = code
 */
const SHELL_TAB_WIDGET_CODE = 'shell-tab'
@Widget({
  name: SHELL_TAB_WIDGET_CODE,
  enableCommonTitleBar: true,
  enableDataConfig: true,
  showIfNoData: true,
})
@Component({
  selector: 'lib-shell-tab',
  templateUrl: './shell-tab.component.html',
  styleUrls: ['./shell-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShellTabComponent extends WidgetBase {

  @Property({
    isArray: true,
    type: PropertyTypes.Object,
    userCustom: true,
    objectOption: {
      objPropertyOptions: [{
        displayName: 'portlet',
        name: 'portletIds',
        type: PropertyTypes.Help2,
        isArray: true,
        help2Option: {
          preset: 'eppPortlet',
          valueField: 'id',
          labelField: 'name',
        }
      }, {
        name: 'title',
        displayName: '标签名',
      }, {
        name: 'rightJump',
        ...dataJumpOption,
      }]
    }
  }) tabConfigs: Tab[]

  activeTab: Tab
  data
  readonly JumpTypes = JumpTypes
  readonly IGIX_HOME_PATH = WEB_PATH_HOME

  // @ViewChild(PortletComponent) portletComp: PortletComponent
  @ViewChildren(PortletComponent) portletComps: QueryList<PortletComponent>

  constructor(
    public portletRepo: PortletRepo,
    public cd: ChangeDetectorRef,
    public widgetDevkitService: WidgetDevkitService,
    public dataService: WidgetDataService,
    public route: ActivatedRoute,
    public shellService: ShellService,
  ) {
    super()
  }

  async ngOnInit() {
    if (!this.tabConfigs) return
    await this.calcPageFilterInit()
    // Load portlets for all tabs
    await this.refreshPortletsByIds();
    // this.activeTab = this.tabConfigs[0]
    this.setActiveTab();
    this.dataService.loadData().subscribe(res => {
      this.data = res
      this.cd.markForCheck()
    })
  }
  async calcPageFilterInit() {
    const { queryParams } = this.route.snapshot
    const PageFilterInit = this.shellService.getPageFilterConfig()
    if (!PageFilterInit) return
    //   PageFilterInit.forEach(async filter => {
    //     // 先得出 val：
    //     // 每个 pFilter 对应一个 fs，也就在这时对应了一个 val，
    //     // 如果不在 url 参数里，就根据 fs 取默认值
    //     const value = queryParams[filter.schema.code]
    //       || await FilterSchema.getDefaultValue(filter.schema)
    //     this.pageFilterValues.push({ filter, value })
    //     // this.setFilterValue(filter,value)
    // })
    // this.cd.markForCheck()
    // const promises = PageFilterInit.map(async filter => {
    //   // 先得出 val：
    //   // 每个 pFilter 对应一个 fs，也就在这时对应了一个 val，
    //   // 如果不在 url 参数里，就根据 fs 取默认值
    //   const value = queryParams[filter.schema.code]
    //     || await FilterSchema.getDefaultValue(filter.schema)
    //   return {
    //     filter,
    //     value
    //   }
    //   // this.pageFilterValues.push({ filter, value })
    // })
    // this.pageFilterValues = await Promise.all(promises);
    this.pageFilterValues = PageFilterInit.map(filter => {
      return {
        filter: filter.filter,
        value: filter.val
      }
    })
  }
  getTitle(titleTmpl) {
    // debugger
    try {
      return tmpl2(titleTmpl, this.data, {}, 0)
    } catch (error) {
    }
  }
  async onPropChange(propName: string) {
    if (!this.tabConfigs) return
    await this.refreshPortletsByIds();
    // this.activeTab = this.tabConfigs[0]
    if(propName==='tabConfigs'){
      this.setActiveTab();
    }
  }

  async onRefresh() {
    await this.refreshPortletsByIds();
    this.setActiveTab();
  }
  hasAclInPortlets(portlets: any[]): boolean {
    return Array.isArray(portlets) && portlets.some((portlet) => !!portlet.hasAcl);
  }
    /**
   * Sets the activeTab to the first tab with permissions.
   */
  setActiveTab(): void {
    const previousActiveTab = this.activeTab; // Store the previous active tab
    this.activeTab =null;
    if (!this.tabConfigs || this.tabConfigs.length === 0) {
      return;
    }
    this.activeTab = this.tabConfigs.find(tab => 
      tab.feOnly && tab.feOnly.portlets && this.hasAclInPortlets(tab.feOnly.portlets)
    );
    // Trigger change detection if activeTab changes
    if (this.activeTab !== previousActiveTab) {
      this.cd.markForCheck();
    }
  }

  async refreshPortletsByIds(): Promise<void> {
    if (!this.tabConfigs) return
    const loadPromises = this.tabConfigs.map(c => {
      if (!c.feOnly) c.feOnly = {}
      if (!c.portletIds) c.portletIds = [];
      // 兼容老的 portletId
      if (c.portletId && (!c.portletIds || !c.portletIds[0])) c.portletIds = [c.portletId]

      const portletIds = c.portletIds.filter(id => id) || [];
      if (portletIds.length === 0) {
        c.feOnly.portlets = [];
        return Promise.resolve(); // 空 ID 列表，直接完成
      }
      
      const getPortlets$ = portletIds.map(id => this.portletRepo.getPortletById(id));

      // forkJoin(getPortlets$).subscribe(ps => {
      //   c.feOnly.portlets = ps
      //   this.cd.markForCheck()
      // })
      return forkJoin(getPortlets$).toPromise().then(ps => {
        c.feOnly!.portlets = ps;
      });
    })
    // this.activeTab = this.tabConfigs[0]
    await Promise.all(loadPromises);
    this.cd.markForCheck();
  }

  handleClickRightTopJump() {
    this.widgetDevkitService.jumpWithData(this.activeTab.rightJump, this.data && this.data[0] || {})
  }

  /** 不容易报错的获取第一个 portlet */
  getFirstPortletOfTab(tab: Tab) {
    return tab
      && tab.feOnly
      && tab.feOnly.portlets
      && tab.feOnly.portlets[0]
      && tab.feOnly.portlets[0].name
  }

  /**
   * 当前页面所有有值的页面级筛选的筛选信息、值，
   * 当筛选值变化时保存、合并进来，无重复项，
   * 用于切换容器内标签时从此处获取筛选信息
   */
  pageFilterValues: {
    filter: PageFilterConfig
    value
  }[] = []

  public setFilterValue(filter: PageFilterConfig, value: any) {
    // 找到命中的部件（不一定有），应用筛选
    filter.targets.forEach(target => {
      if (!target || !target.enabled) return
      // const targetPComp = this.portletComp
      const targetPComp = this.portletComps
        .find(pComp => pComp.portletId === target.portletId
          || pComp.portlet.id === target.portletId)
      if (!(targetPComp && targetPComp.widgetComp)) return
      targetPComp.widgetComp.setFilterDpValues([{
        dpId: target.dpId,
        value: value,
        fs: filter.schema,
      }])
    })

    // 记下来
    this.mergeToPageFilterValues(filter, value)
  }

  mergeToPageFilterValues(filter: PageFilterConfig, value: any) {
    ArrUtil.RemovePredicateOnce(this.pageFilterValues, pfv => pfv.filter.schema === filter.schema)
    this.pageFilterValues.push({ filter, value })
  }

  // handleWCompCreated(wComp: WidgetComponent, portlet: EppPortlet) {
  //   let target: {
  //     portletId?: string;
  //     dpId?: string;
  //     enabled?: boolean;
  //   }
  //   const curWPageFilterValue = this.pageFilterValues.find(iFilterValue => {
  //     target = iFilterValue.filter.targets.find(t => t && t.dpId && t.portletId === portlet.id)
  //     return !!target
  //   })
  //   if (curWPageFilterValue) {
  //     wComp.setFilterDpValues([{
  //       dpId: target.dpId,
  //       value: curWPageFilterValue.value,
  //       fs: curWPageFilterValue.filter.schema
  //     }], false)
  //   }
  // }

  handleWCompCreated(wComp: WidgetComponent, portlet: EppPortlet) {
    const curWPageFilterValue = this.pageFilterValues.map(parent => {
      const activeChildren = parent.filter.targets.filter(t => t && t.dpId && t.enabled && t.portletId === portlet.id);

      if (activeChildren.length === 0) {
        return [];
      }
      return activeChildren.map(child => ({
        dpId: child.dpId,
        value: parent.value,
        fs: parent.filter.schema
      }));
    }).reduce((acc, cur) => acc.concat(cur), []);

    if (curWPageFilterValue) {
      // wComp.setFilterDpValues([{
      //   dpId: target.dpId,
      //   value: curWPageFilterValue.value,
      //   fs: curWPageFilterValue.filter.schema
      // }], false)
      wComp.setFilterDpValues(curWPageFilterValue, false);
    }
  }
}

registerInnerWidget({
  widgetComponent: ShellTabComponent,
  baseUrl: '',
  id: SHELL_TAB_WIDGET_CODE,
  name: SHELL_TAB_WIDGET_CODE,
  version: '6',
  isDevMode: true,
})
